var React = require('react');
var ReactNative = require('react-native');
var Globals = require('./Globals');
var {
  View,
  StyleSheet,
} = ReactNative;

var ReUpTabBar = require('./ReUpTabBar');

var EarnPay = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      visibleFeature : null
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor",.6);
    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
    var shouldShowCheckInFirst = typeof this.props.extras !== 'undefined' && typeof this.props.extras.showCheckInFirst !== 'undefined' && this.props.extras.showCheckInFirst;
    var borderRadius = typeof this.props.extras !== 'undefined' && typeof this.props.extras.borderRadius !== 'undefined' ? this.props.extras.borderRadius : 0;

    return (
      <View clipToSubviews={true} style={{flex:1, backgroundColor:generalColor, alignSelf:'stretch', borderRadius:borderRadius, overflow:'hidden', flexDirection:'column'}}
        onLayout={(evt)=>{thisThing.setState({layout:{width:evt.nativeEvent.layout.width, height:evt.nativeEvent.layout.height}})}}>
        <View style={{flex:1, overflow:'hidden', marginTop:Globals.TAB_BAR_HEIGHT}}>
        {this.state.visibleFeature}
        </View>
        <View style={{position:'absolute', top:this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, left:0, right:0, height:Globals.TAB_BAR_HEIGHT}}>
          <ReUpTabBar
            style={{flex:1, alignSelf:'stretch'}}
            textColor={generalTitleColor}
            barColor={iconColor}
            rippleColor={rippleColor}
            iconColor={iconColor}
            layout={this.state.layout}
            canDismiss={false}
            initialTabSelected={shouldShowCheckInFirst ? 1 : 0}
            showFeature={(feature)=>
            {
              var layout = {width:thisThing.state.layout.width, height:thisThing.state.layout.height-40 - ((thisThing.props.extras && thisThing.props.extras.shouldHideActionBar) ? Globals.ACTION_BAR_HEIGHT : 0)}
              var featureView = appActions.featureForData(feature, layout, appManager, thisThing.props.extras);
              thisThing.setState({visibleFeature:featureView})
            }}
            hideFeature={()=>
            {

            }}
            buttonFeatures={[appManager.getFeatureForName("UseCredit"), appManager.getFeatureForName("CheckIn")]}
            />
        </View>
      </View>
    );
  }
});

EarnPay.dataDependencies = [];

module.exports = EarnPay;



// WEBPACK FOOTER //
// ./src/EarnPay.js